import React from 'react'
import Modal from '../../shared/Modal'
import Editor from '../../shared/Editor'
import ClaimCustomizeIframe from './ClaimCustomizeIframe'

class ClaimPayloadForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showConfirmationModal: false,
      disabled: true
    }
  }

  formSubmitHandler(e) {
    let button = document.querySelector('.submit-form')
    button.textContent = 'Sending Request...'
    button.disabled = true
    $.post(`/claims/${this.props.id}/submit`, {}, (response) => {
      if (response.success) {
        window.location = `/claims/${this.props.id}`
      } else {
        if (response.unauthorized) {
          toartr.error(response.error_message)
          window.location = response.location
        } else {
          toastr.error(response.message)
          button.textContent = 'Send my Request'
          button.disabled = false
        }
      }
    })
  }

  handleOnCheck () {
    const element = 'input[name="claim-submit-accept-checkbox"]'
    const checked = $(element).length == $(element + ':checked').length
    this.setState({
      disabled: !checked
    })
  }

  legalWarningText () {
    const date = new Date()
    const finalDate = moment(date).format('MM/DD/YYYY')
    return (
      <div className='legal-warning-text'>
        Please review the warning statements listed below, and click <b>I ACCEPT</b> at the bottom of the page to complete the claim filing process.<br />
        <b>CLAIM FRAUD STATEMENTS</b><br />
        <b>Fraud Warning</b><br />
        For your protection, the laws of several states, including Alaska, Arizona, Arkansas,
        Delaware, Idaho, Indiana, Louisiana,Maine, Maryland, New Mexico, Ohio, Oklahoma, Rhode Island, Tennessee,
        Texas, Virginia, Washington, and West Virginia require the following statement to appear on this claim form:
        Any person who knowingly and with the intent to injure, defraud or deceive an insurance company presents a 
        false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an 
        application for insurance is guilty of a crime and may be subject to fines and confinement in prison.<br />
        <b>Fraud Warning for Alabama Residents</b><br />
        For your protection, Alabama law requires the following to appear on this claim form:<br />
        Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or who 
        knowingly presents false information in an application for insurance is guilty of a crime and may be 
        subject to restitution fines or confinement in prison, or any combination thereof.<br />
        <b>Fraud Warning for California Residents</b><br />
        For your protection, California law requires the following to appear on this claim form:<br />
        Any person who knowingly presents a false or fraudulent claim for the payment of a loss is guilty of a crime 
        and may be subject to fines and confinement in state prison.<br />
        <b>Fraud Warning for Colorado Residents</b><br />
        For your protection, Colorado law requires the following to appear on this claim form:<br />
        It is unlawful to knowingly provide false, incomplete, or misleading facts or information to an insurance company 
        for the purpose of defrauding or attempting to defraud the company. Penalties may include imprisonment, fines, 
        denial of insurance, and civil damages. Any insurance company or agent of an insurance company who knowingly provides false, 
        incomplete, or misleading facts or information to a policyholder or claimant for the purpose of defrauding or 
        attempting to defraud the policyholder or claimant with regard to a settlement or award payable from insurance proceeds 
        shall be reported to the Colorado Division of Insurance within the Department of Regulatory Agencies.<br />
        <b>Fraud Warning for District of Columbia Residents</b><br />
        For your protection, the District of Columbia requires the following to appear on this claim form:<br />
        WARNING: It is a crime to provide false or misleading information to an insurer for the purpose of defrauding the insurer or 
        any other person. Penalties include imprisonment and/or fines. In addition, an insurer may deny insurance benefits, 
        if false information materially related to a claim was provided by the applicant.<br />
        <b>Fraud Warning for Florida Residents</b><br />
        For your protection, Florida law requires the following to appear on this claim form:<br />
        Any person who knowingly and with intent to injure, defraud or deceive any insurer, files a statement of claim or 
        an application containing false, incomplete or misleading information is guilty of a felony of the third degree.<br />
        <b>Fraud Warning for Kentucky Residents</b><br />
        For your protection, Kentucky law requires the following to appear on this claim form:<br />
        Any person who knowingly and with intent to defraud any insurance company or other person files a statement of 
        claim containing any materially false information or conceals, for the purpose of misleading, information concerning 
        any fact material thereto commits a fraudulent insurance act, which is a crime.<br />
        <b>Fraud Warning for Minnesota Residents</b><br />
        For your protection, Minnesota law requires the following to appear on this claim form:<br />
        A person who files a claim with intent to defraud or helps commit a fraud against an insurer is guilty of a crime.<br />
        <b>Fraud Warning for New Hampshire Residents</b><br />
        For your protection, New Hampshire law requires the following to appear on this claim form:<br />
        Any person who, with a purpose to injure, defraud, or deceive any insurance company, files a statement of claim 
        containing any false, incomplete, or misleading information is subject to prosecution and punishment for insurance fraud, 
        as provided in RSA 638.20.<br />
        <b>Fraud Warning for New Jersey Residents</b><br />
        For your protection, New Jersey law requires the following to appear on this claim form:<br />
        Any person who knowingly and with intent to defraud any insurance company or other persons, files a statement of claim 
        containing any materially false information, or conceals for the purpose of misleading, information concerning any fact, 
        material thereto, commits a fraudulent insurance act, which is a crime, subject to criminal prosecution and civil penalties.<br />
        <big><b>Fraud Warning for New York Residents</b><br />
        For your protection, New York law requires the following to appear on this claim form:<br />
        Any person who knowingly and with the intent to defraud any insurance company or other person files an application for 
        insurance or statement of claim containing any materially false information, or conceals for the purpose of misleading, 
        information concerning any fact material thereto, commits a fraudulent insurance act, which is a crime, and shall also be 
        subject to a civil penalty not to exceed five thousand dollars and the stated value of the claim for each such violation.</big><br />
        <b>Fraud Warning for Pennsylvania Residents</b><br />
        For your protection, Pennsylvania law requires the following to appear on this claim form:<br />
        Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or 
        statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning 
        any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.<br />
        <b>Fraud Warning for Puerto Rico Residents</b><br />
        For your protection, Puerto Rico law requires the following to appear on this claim form:<br />
        Any person who knowingly and with the intention of defrauding presents false information in an insurance application, or 
        presents, helps, or causes the presentation of a fraudulent claim for the payment of a loss or any other benefit, or presents 
        more than one claim for the same damage or loss, shall incur a felony and, upon conviction, shall be sanctioned for each violation 
        with the penalty of a fine of not less than five thousand dollars ($5,000) and not more than ten thousand dollars ($10,000), 
        or a fixed term of imprisonment for three (3) years, or both penalties. If aggravating circumstances are present, the penalty 
        thus established may be increased to a maximum of five (5) years; if extenuating circumstances are present, it may be reduced 
        to a minimum of two (2) years.<br />
        I have read and understand the fraud notices listed above. I also understand that should my claim be overpaid for any reason, 
        it is my obligation to repay any such overpayment. The statements and the information provided are true and complete to the 
        best of my knowledge and belief.<br />
        <b>Date:	{finalDate} </b> <br />
        <b>Signature:</b>	<br />
        Please note that by checking "I accept" and then clicking the "Submit my Request" button, you are submitting this claim to Unum. 
        Once clicked, no further changes can be made to the information you will have submitted.
      </div>
    )
  }

  renderPayload() {
    const payload = JSON.stringify(this.props.payload, undefined, 2)
    return (
      <Editor
        editorMode='application/json'
        content={payload}
        readOnly={true}
      />
    )
  }

  requestSavedHandler() {
    toastr.success('Successfully saved your request.')
    window.location = '/claims'
  }

  renderConfirmationModal() {
    const showConfirmationModal = this.state.showConfirmationModal
    if (showConfirmationModal) {
      return (
        <Modal
          show={showConfirmationModal}
          title='One more thing before you submit your request...'
          hideModalInParent={ (e) => this.setState({ showConfirmationModal: false }) }
          id={this.props.id}
          approve={this.formSubmitHandler.bind(this)}
          submitClaimRequest={true}
          disabled={this.state.disabled}
        >
          <div className="claim-submit-request-modal-body">
            <div className="row fixed-header-body">
              <div>
                <h4>Fraud Warning</h4>
              </div>
            </div>
            <div className="row fraud-warning">
              <div className="scrollable-body">
                {this.legalWarningText()}
              </div>
            </div>
            <br />
            <div className='row'>
              <div className="checkbox-terms">
                <input type="checkbox" name="claim-submit-accept-checkbox"  onClick={() => this.handleOnCheck()} />  I accept.
              </div>
            </div>
          </div>
        </Modal>
      )
    }
  }

  renderSubmitClaimCheckDiv() {
    const { customizableScreenContent, requestRecipient } = this.props
    const { save_submit_claim } = customizableScreenContent

    if (save_submit_claim) {
      return <ClaimCustomizeIframe content={save_submit_claim} />
    }

    const faCheckStyle = {
      fontSize: 48,
      color: 'green'
    }
    return (
      <div className='submit-claim-check'>
        <i className="submit-claim-circle-check fa fa-check-circle" style={ faCheckStyle }></i>
        <div className='submit-claim-circle-text'>
          {`Your request has been reviewed by LeaveLogic and is ready to be submitted to ${requestRecipient}.`}
          <div className="submit-claim-info-text">
            {`Once you submit your request to Unum, any changes to your LeavePlan in LeaveLogic will not automatically update Unum. You can contact us through the in-app chat for more help.`}
            <br />
            {`Click "Submit my Request" to send your request to ${requestRecipient} now or "Save my Request" to come back later.`}
          </div>
        </div>
      </div>
    )
  }

  renderNormalForm() {
    return (
      <div className="text-center">
        <div className='submit-claim-thankyou-text'>
          {`Thanks! Now it’s time to file your request with ${this.props.requestRecipient}`}
        </div>
        { this.renderSubmitClaimCheckDiv() }
        <div className= 'row'>
          <div className='col-md-6'>
          </div>
          <div className='col-md-6 claim-submission-disabled-text'>
            <span className={`${this.props.claimSubmissionAllowed ? 'hidden' : 'shown'}`}>
              { this.props.submissionDisabledDescription}
              </span>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <button
              className='request-btn save-request btn btn-dark btn-bdr-rds'
              onClick={this.requestSavedHandler}>
              Save my Request
            </button>
          </div>
          <div className='col-md-6'>
            <button
              className={`request-btn send-request btn btn-bdr-rds submit-form ${this.props.claimSubmissionAllowed ? 'btn-success' : 'disabled'}`}
              disabled={!this.props.claimSubmissionAllowed}
              onClick={this.confirmationModalOrSubmit.bind(this)}>
              Submit my Request
            </button>
          </div>
        </div>
      </div>
    )

  }

  renderEditorForm() {
    return (
      <div>
        <div className='payload-form'>
          <div className='payload-title'>
            Request
          </div>
          { this.renderPayload() }
          <div className='form-group'>
            <button
              className='submit-form btn btn-primary'
              onClick={this.confirmationModalOrSubmit.bind(this)}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    )
  }

  confirmationModalOrSubmit() {
    if (this.props.requestRecipient == 'Unum') {
      this.setState({ showConfirmationModal: true })
    } else {
      this.formSubmitHandler()
    }
  }

  renderEditorModeSwitch() {
    let switchText = 'Switch to Editor Mode'
    if (this.props.editorMode) {
      switchText = 'Switch to Normal Mode'
    }
    return this.props.isAdmin ? (
      <span
        className='submit-view-switch'
        onClick={(e) => this.props.onFormPropertiesChanged({editorMode: !this.props.editorMode})}
      >
        { switchText }
      </span>
    ) : null
  }

  renderForm() {
    if (this.props.editorMode) {
      return this.renderEditorForm()
    } else {
      return this.renderNormalForm()
    }
  }

  render () {
    return (
      <div className='claim-container'>
        <div className='submit-view-buttons'>
          <span
            className='submit-view-switch'
            onClick={this.props.onPrevSection}
          >
            Go Back
          </span>
          { this.renderEditorModeSwitch() }
        </div>
        { this.renderForm() }
        { this.renderConfirmationModal() }
      </div>
    )
  }
}

export default ClaimPayloadForm;